import { Box, useTheme } from "@mui/material";
import { useContext, useState } from "react";

import SimpleModalFix from "@/components/SimpleModalFix.tsx";
import TemplateContainer from "@/components/Templates/TemplateContainer.tsx";
import { FeedContext } from "@/models/FeedContextProvider.tsx";

export default function TemplatesModal({
  open,
  useSelectedTemplate,
}: {
  open: boolean;
  useSelectedTemplate?: (tts: string) => void;
}) {
  const { setTemplatesModal } = useContext(FeedContext);
  const [hasChanges, setHasChanges] = useState<boolean>(false);
  const theme = useTheme();

  return (
    <SimpleModalFix
      confirmDiscard={hasChanges}
      closeModal={() => setTemplatesModal(false)}
      open={open}
      title="Use a template"
      sx={{ width: "900px", height: "600px", boxShadow: hasChanges ? `0 0 0 2px ${theme.palette.info.main}` : "" }}
    >
      <Box sx={{ height: "530px" }}>
        <TemplateContainer
          allowTemplateUse={true}
          showRightPanel={true}
          header={false}
          setDisableCloseModal={setHasChanges}
          useSelectedTemplate={useSelectedTemplate}
        />
      </Box>
    </SimpleModalFix>
  );
}
